import LoginForm from '@/components/forms/LoginForm';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getRedirectRoute } from '@/utils/redirect';
import { getPendingTenantSelectionFlag, clearPendingTenantSelectionFlag } from '@/utils/loginFlow';
import AuthPageShell from '@/components/auth/AuthPageShell';
import { useTranslation } from 'react-i18next';

type LoginSearch = {
  redirect?: string;
  method?: 'sms';
  casError?: boolean;
};

export const Route = createFileRoute('/login')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: (search.redirect as string) || undefined,
    method: search.method === 'sms' ? 'sms' : undefined,
    casError: search.casError === 1 || search.casError === '1' || search.casError === true ? true : undefined
  }),
  beforeLoad: ({ context }) => {
    const hasAuth = !!context?.auth;
    const pendingFlag = getPendingTenantSelectionFlag();
    if (!hasAuth) {
      clearPendingTenantSelectionFlag();
    }
    console.log('[LoginFlow] /login beforeLoad: hasAuth=', hasAuth, 'pendingTenantFlag=', pendingFlag);
    if (hasAuth && !pendingFlag) {
      const redirectRoute = getRedirectRoute(context.auth);
      console.log('[LoginFlow] /login beforeLoad: REDIRECTING to', redirectRoute);
      throw redirect({
        to: redirectRoute
      });
    }
    console.log('[LoginFlow] /login beforeLoad: NOT redirecting (stay on login)');
  }
});

function RouteComponent() {
  const { redirect, method, casError } = Route.useSearch();
  const { t } = useTranslation(['auth', 'common']);
  
  return (
    <AuthPageShell
      title={t('auth:login.title')}
      subtitle={t('auth:login.subtitle')}
      decoration="default"
      showFooter
    >
      <LoginForm redirect={redirect} method={method} casError={casError} />
    </AuthPageShell>
  );
}
